import React, { useEffect } from "react";
// import { Router } from "react-router-dom";
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
// import history from "./utils/history";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";
import SnakeBar from "./components/common/SnakeBar";
import LogRocket from "logrocket";
import BasicRequireInfo from "./pages/Auth/BasicInfoRequire";

// import SmartLook from "smartlook-client";
// import { rootReducersState } from "./reducers";
// import { useSelector } from "react-redux";
// import UserMessage from '../src/pages/MessagesData/index';

const App = () => {

  useEffect(() => {
    // LogRocket integration
    const logRocketAppId = process.env.REACT_APP_LOG_ROCKET;
    if (logRocketAppId) {
      LogRocket.init(logRocketAppId);
    }

    // Smartlook integration
    // const smartLookAppId = process.env.REACT_APP_SMART_LOOK;
    // if (smartLookAppId) {
    //   SmartLook.init(smartLookAppId);
    // }
  }, []);
  // const token = useSelector((state: rootReducersState) => state.session.token);
  // const isLoggedIn = !!token;

  return (
    <>
    
     <ScrollToTop />
     <BasicRequireInfo>
      <PublicRoutes />
       <PrivateRoutes />
      {/* <UserMessage /> */}
          </BasicRequireInfo>
      <SnakeBar />

 
    </>
  );
};

const AppWrapper = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default AppWrapper;

